module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/LTE1-6e40a2de188f2b47d752c41dec57ac56.svg";